import { DEXFColor } from '@inter-ikea-storageone/range';
import { capitalizeFirstLetter } from './utils';
import { IProductFilterAttribute } from '@inter-ikea-kompis/types';

const transformAppearance = (filterAttribute: IProductFilterAttribute[]) => {
  // DEXF color filter header code
  const COLOR_HEADER_CODE = '38764';
  const colorFilterAttrs = filterAttribute.filter(
    filter => filter.headerCode === COLOR_HEADER_CODE
  );

  if (!colorFilterAttrs) {
    // eslint-disable-next-line no-console
    console.warn('Color filter not available for product');
    return [];
  }

  return colorFilterAttrs.map(colorAttr => {
    let color: string;
    switch (colorAttr.valueCode) {
      case DEXFColor.BROWN:
        color = '#644029';
        break;
      case DEXFColor.BLACK:
        color = '#111111';
        break;
      case DEXFColor.BEIGE:
        color = '#D6BDA1';
        break;
      case DEXFColor.WHITE:
        color = '#fafafa';
        break;
      case DEXFColor.GREY:
        color = '#959595';
        break;
      case DEXFColor.YELLOW:
        color = '#ffdb00';
        break;
      case DEXFColor.BLUE:
        color = '#0058a3';
        break;
      case DEXFColor.RED:
        color = '#ff0000';
        break;
      case DEXFColor.GREEN:
        color = '#0E6251';
        break;
      case DEXFColor.TURQUOISE:
        color = '#0cafbd';
        break;
      case DEXFColor.ORANGE:
        color = '#FF6600';
        break;
      case DEXFColor.PINK:
        color = '#fc3468';
        break;
      case DEXFColor.MULTICOLOR:
        color = '#ee82ee';
        break;
      default:
        // eslint-disable-next-line no-console
        console.warn('Unmapped color attribute', colorAttr.valueCode, colorAttr.value);
        color = '#FF69B4'; // Hot pink color to easy see that something is wrong
        break;
    }
    return {
      id: colorAttr.valueCode,
      color,
      name: capitalizeFirstLetter(colorAttr.value)
    };
  });
};

export default transformAppearance;
